<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
@use '@/assets/scss/variables.scss' as vars;
@use '@/assets/scss/common.scss' as coms;

/* 响应式设计 */
@media (max-width: 768px) {
  html {
    font-size: 14px;
  }
  
  .el-dialog {
    width: 90% !important;
    margin: 20px auto !important;
  }
  
  .el-message {
    min-width: 300px !important;
  }
}
</style>
